import { useEffect, useRef } from "react";
import styles from "./Modal.module.css";
import { AlertTriangle, CheckCircle, XCircle, Trash2 } from "lucide-react";

const Modal = ({
  type = "success",
  title,
  message,
  onClose,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  useEffect(() => {
    if ((type === "confirm" || type === "delete") && confirmBtnRef.current) {
      confirmBtnRef.current.focus();
    }
  }, [type]);

  const renderIcon = () => {
    // Mapping types to specific style classes
    const iconClass = styles[type] || styles.success;

    switch (type) {
      case "warning":
      case "confirm":
        return <div className={`${styles.icon} ${iconClass}`}><AlertTriangle size={28} /></div>;
      case "error":
        return <div className={`${styles.icon} ${iconClass}`}><XCircle size={28} /></div>;
      case "delete":
        return <div className={`${styles.icon} ${styles.danger}`}><Trash2 size={28} /></div>;
      default:
        return <div className={`${styles.icon} ${styles.success}`}><CheckCircle size={28} /></div>;
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modalBox} onClick={(e) => e.stopPropagation()}>
        {renderIcon()}
        {title && <h2 className={styles.title}>{title}</h2>}
        {message && <p className={styles.modalMessage}>{message}</p>}

        {type === "confirm" || type === "delete" ? (
          <div className={styles.actions}>
            <button className={`${styles.btn} ${styles.btnCancel}`} onClick={onClose}>
              {cancelText}
            </button>
            <button
              ref={confirmBtnRef}
              className={`${styles.btn} ${type === "delete" ? styles.btnDanger : styles.btnConfirm}`}
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        ) : (
          <button className={styles.modalButton} onClick={onClose} autoFocus>
            Okay
          </button>
        )}
      </div>
    </div>
  );
};

export default Modal;